import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { LoaderConfig } from "../shared/components/loader/loader.component";

export interface IProgress {
    activity: string,
    title: string,
    value: number;
}

@Injectable({ providedIn: 'root' })
export class LoaderService {

    // GLOBAL LOADING
    protected _loading$: BehaviorSubject<boolean>;
    public get loading$(): Observable<boolean> { return this._loading$.asObservable(); };


    protected _loading: boolean;
    public get loading(): boolean { return this._loading; }
    public set loading(v: boolean) {
        // console.trace('loading', v);
        this._loading = v;
        this._loading$.next(this._loading);
    }

    // LOCAL LOADING
    protected _local$: BehaviorSubject<boolean>;
    public get local$(): Observable<boolean> { return this._loading$.asObservable(); };

    protected _local: boolean;
    public get local(): boolean { return this._local; }
    public set local(v: boolean) {
        this._local = v;
        this._local$.next(this._local);
    }


    public progress: EventEmitter<IProgress> = new EventEmitter<IProgress>();
    protected _config: LoaderConfig;
    public get config(): LoaderConfig { return this._config; }

    constructor() {
        this._loading$ = new BehaviorSubject<boolean>(false);
        this._loading = false;
        this._config = {
            backdropBorderRadius: '0',
            backdropBackgroundColour: 'rgba(250,250,250, 1)',
            fullScreenBackdrop: true,
            primaryColour: '#a5d256',
        };
    }
}
